
import { useEffect } from 'react'
import { classes, style } from 'typestyle'

/* Hooks ======================================================================================== */
import useFetch from '../../../hooks/use-fetch'
import useValue from '../../../hooks/use-value'

/* Common ======================================================================================= */
import { structureObj } from '../../../share/obj-equal'

/* Components =================================================================================== */
import { Notification } from '../../../components/notification'

/* Styles ======================================================================================= */
import { primaryColorMedium } from '../../../styles/styleset/primary-color-medium/primaryColorMedium'
import { useTheme } from '../../../components/theme'

export const Switch = (props: any) => {
  const { value, pathName, onUpdate, name, isAsync = true } = props
  const [checked, $checked] = useValue(value)
  const [patch, $patch] = useFetch()
  const [theme] =  useTheme()

  useEffect(() => {
    $checked.set(value)
  }, [value])

  return (
    <div
      className={classes(checked ? style({ background: theme.baselines.primary.color.medium}) : style({ background: 'rgb(200,200,200)' }))}
      onClick={() => {
        if (isAsync)
          $patch
            .patch({
              url: `${process.env.REACT_APP_API_URL}${pathName}`,
              body: structureObj({ [name]: !checked }),
            })
            .then(() => {
              if (onUpdate) {
                onUpdate()
              }
              Notification.push({ label: 'Successfully updated!' })
            })

        $checked.set(!checked)
      }}
      style={{
        cursor: 'pointer',
        height: 22,
        width: 34.84,
        borderRadius: 34.84 / 2,
        display: 'flex',
        justifyContent: checked ? 'flex-start' : 'flex-end',
        alignItems: 'center',
        padding: '0 2px',
        transition: '0.2s all',
      }}
    >
      <div
        style={{
          height: 18,
          width: 18,
          display: 'inline-block',
          background: 'white',
          borderRadius: 11,
        }}
      />
    </div>
  )
}
